// extracted by mini-css-extract-plugin
export var addButton = "_fw-0";
export var border = "_fw-8";
export var check = "_fw-h";
export var danger = "_fw-6";
export var dropdownContainer = "_fw-1";
export var editModalBody = "_fw-j";
export var footerContainer = "_fw-i";
export var fullWidth = "_fw-a";
export var hide = "_fw-9";
export var icon = "_fw-3";
export var input = "_fw-7";
export var inputFlex = "_fw-b";
export var inputWrapper = "_fw-c";
export var manualFocus = "_fw-5";
export var optionButton = "_fw-4";
export var pillWrapper = "_fw-e";
export var pointer = "_fw-2";
export var showOverflow = "_fw-f";
export var tagsFlex = "_fw-d";
export var xButton = "_fw-g";